import { render, staticRenderFns } from "./ownaccount.vue?vue&type=template&id=25bd9782&scoped=true&"
import script from "./ownaccount.vue?vue&type=script&lang=js&"
export * from "./ownaccount.vue?vue&type=script&lang=js&"
import style0 from "./ownaccount.vue?vue&type=style&index=0&id=25bd9782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bd9782",
  null
  
)

export default component.exports